import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'precios'
})
export class PreciosPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
